<template>
  <div class="request-home">
    <vue-qrcode :value="url" width="300"/>
  </div>
</template>

<script>
// @ is an alias to /src
import VueQrcode from 'vue-qrcode'

export default {
  name: "Home",
  components: {
    VueQrcode,
  },
  data() {
    return {
      url: 'https://naver.com/param?QxdDLD'
    };
  },
  mounted(){
    this.isShow = true;
    if (screen.width > 768) {
      var mvp = document.getElementById('myViewport');
      mvp.setAttribute('content','width=device-width, initial-scale=1');
    }
  }
};
</script>
